import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import app from 'common/builder/components/chart/FlowChart/app'
import { STATES, DBL_CLICK_TIME } from 'common/builder/components/chart/FlowChart/config'
import withIsHover from 'common/builder/components/chart/FlowChart/nodes/shared/WithIsHover'

import ArrowWrapper from './ArrowWrapper'
import withPosition from './PositionProvider'
import StartDot from './StartDot'
import { Tooltip } from './Tooltip/Tooltip'

const DOT_RADIUS = 11

class Connector extends PureComponent {
  static propTypes = {
    color: PropTypes.string,
    id: PropTypes.string,
    isCreating: PropTypes.bool.isRequired,
    isHover: PropTypes.bool,
    offsetX: PropTypes.number,
    onChangeEnd: PropTypes.func,
    onChangeStart: PropTypes.func,
    position: PropTypes.object,
    readonly: PropTypes.bool,
    sourceId: PropTypes.string,
    targetId: PropTypes.string,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
  }

  static defaultProps = {
    color: '#8492a6',
    readonly: false,
  }

  state = {
    showTooltip: false,
  }

  getHoverData = (e) => {
    const { isFromStartingStep, id } = this.props
    const mousePoint = e.data.global.clone()
    const getMenuPosition = (point) => {
      mousePoint.copyTo(point)
    }

    return {
      name: 'connector',
      id,
      isDeletable: !isFromStartingStep,
      getMenuPosition,
    }
  }

  handleArrowTap = (e) => {
    app.setHover(this.getHoverData(e))
  }

  handleArrowMouseOver = (e) => {
    if (app.state !== STATES.NORMAL) {
      return
    }

    // Enabling endpoints highlight
    const { sourceId, targetId } = this.props
    app.highlight([sourceId, targetId])

    app.setHover(this.getHoverData(e))
  }

  handleArrowMouseOut = (e) => {
    app.dropHover()

    // We shouldn't drop highlight while selecting frames
    if (app.state !== STATES.NORMAL) {
      return
    }

    // Disabling endpoints highlight
    app.dropHighlight()
  }

  handleArrowClick = (e) => {
    this.clickTimer = setTimeout(() => {
      app.moveTo(this.props.targetId)
    }, DBL_CLICK_TIME)
  }

  handleArrowDoubleClick = (e) => {
    clearTimeout(this.clickTimer)
    app.moveTo(this.props.sourceId)
  }

  handleDotMouseOver = () => {
    if (this.props.tooltip) this.setState({ showTooltip: true })
  }

  handleDotMouseOut = () => {
    if (this.props.tooltip) this.setState({ showTooltip: false })
  }

  handleDotClick = (e) => {
    const { onChangeStart, sourceId } = this.props
    onChangeStart(sourceId, true)
  }

  handleDotDragStart = (e) => {
    const { onChangeStart, sourceId } = this.props
    onChangeStart(sourceId)
  }

  handleDotDragEnd = (e) => {
    this.props.onChangeEnd()
  }

  render() {
    const { color, isHover, offsetX, position, readonly, sourceId, disabled } = this.props
    const { isCreating, targetId, tooltip } = this.props
    const { disableFlowChartInteractions } = this.props
    const { showTooltip } = this.state
    return (
      <>
        <StartDot
          color={color}
          position={position}
          hasTarget={Boolean(targetId)}
          isHover={isHover}
          offsetX={offsetX}
          onClick={this.handleDotClick}
          onDragEnd={this.handleDotDragEnd}
          onDragStart={this.handleDotDragStart}
          onMouseOut={this.handleDotMouseOut}
          onMouseOver={this.handleDotMouseOver}
          radius={DOT_RADIUS}
          readonly={disableFlowChartInteractions || readonly}
          sourceId={sourceId}
          disabled={disabled}
        />
        <ArrowWrapper
          color={color}
          position={position}
          interactive={!isCreating && !disableFlowChartInteractions}
          isHover={isHover}
          name="connector"
          offsetX={offsetX ? offsetX : DOT_RADIUS}
          onClick={this.handleArrowClick}
          onDoubleClick={this.handleArrowDoubleClick}
          onMouseOut={this.handleArrowMouseOut}
          onMouseOver={this.handleArrowMouseOver}
          onTap={this.handleArrowTap}
        />
        {showTooltip && <Tooltip text={tooltip} position={position} />}
      </>
    )
  }
}

export default withPosition(withIsHover(Connector))
